<template>
  <div class="LocationShow" :class="{ loading }">
    <section class="Hero" :style="heroStyle">
  <div class="Hero__overlay"></div>

  <div class="Hero__inner">
    <h1 :class="isPhone ? 'merriweather-reg-32' : 'merriweather-reg-40'">{{ loc.title }}</h1>
    <div class="Hero__stars" v-if="starsText">{{ starsText }}</div>
    <p :class="isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-26'" v-if="loc.subtitle">{{ loc.subtitle }}</p>

    <div v-if="hasGallery" class="btn-galerie-seminar w-100">
      <div class="galerie-icon df-jsb-aic">
        <img src="../../images/Galerie icone.svg" v-set-alt />
        <p class="raleway-semi-p13 mb-0 ml-2 text-uppercase" @click.prevent="openGallery">Galerie</p>
      </div>
    </div>
  </div>
</section>

<!-- <section v-if="hasGallery" id="gallery" class="GalleryGrid">
  <img
    v-for="(src, i) in loc.gallery_photo_urls"
    :key="i"
    :src="src"
    :alt="`${loc.title} – photo ${i+1}`"
    loading="lazy"
  />
</section> -->

  <div
    v-if="hasGallery && isGalleryOpen"
    class="GalleryModal"
    role="dialog"
    aria-modal="true"
    aria-label="Galerie photos"
    @click.self="closeGallery"
    @keydown.esc="closeGallery"
    tabindex="-1"
    ref="galleryModal"
  >
    <button
      class="GalleryModal__close"
      @click="closeGallery"
      aria-label="Fermer la galerie"
    >
      ×
    </button>

    <div class="GalleryModal__content">
      <img
        v-for="(src, i) in loc.gallery_photo_urls"
        :key="'m'+i"
        :src="src"
        :alt="`${loc.title} – photo ${i+1}`"
        loading="eager"
      />
    </div>
  </div>

    <nav class="AnchorNav" ref="nav">
      <div class="AnchorNav__inner">
        <div class="AnchorNav__scroller">
          <a
            v-for="l in navLinks"
            :key="l.id"
            href="#"
            class="AnchorNav__link"
            @click.prevent="scrollTo(l.id)"
          >
            {{ l.label }}
          </a>
        </div>
      </div>
    </nav>
    <section
      id="address"
      class="AddressHighlight"
      v-if="fullAddress || topHighlights.length"
    >
      <div class="AddressHighlight__container">
        <p class="raleway-reg-p24" v-if="fullAddress">{{ fullAddress }}</p>

        <p class="raleway-reg-p13" v-if="displayAddress">
          <!-- <span class="pin" aria-hidden="true">📍</span> -->
          <button type="button" class="MapOpenBtn" @click="openMap">Voir sur la carte</button>
        </p>


        <div class="AddressHighlight__grid" v-if="topHighlights.length">
          <div class="AHCard" v-for="(h, i) in topHighlights" :key="'h'+i">
            <div class="AHCard__icon" v-html="icons[h.kind] || icons.default"></div>
            <div class="AHCard__label raleway-semi-p16">{{ highlightLabel(h.kind) }}</div>
          </div>
        </div>
      </div>
    </section>
    <MapboxModal
      v-if="showMap"
      access-token="pk.eyJ1IjoiaG9ydGVuc2VncmVlbiIsImEiOiJja3N1Nm9iNGEwNjUyMm9xY2RlMDlwYWsxIn0.AMGi9L_80RYWk4sB5JYU5w"
      :center="[Number(loc.latitude), Number(loc.longitude)]"
      :title="loc.title"
      :address="fullAddress"
      @close="showMap = false"
    />
    <section
      id="intro"
      class="IntroBlock"
      v-if="loc.intro_paragraph || loc.period_text || loc.duration_text || loc.participants_text"
    >
      <!-- Centered headline, spans both columns -->
      <div class="IntroBlock__head">
        <h2 class="IntroBlock__kick" :class="isPhone ? 'merriweather-reg-18' : 'merriweather-reg-32'">Votre séminaire d'exception</h2>
        <h3 class="IntroBlock__big" :class="isPhone ? 'merriweather-reg-32' : 'merriweather-reg-40'">au {{ loc.title }}</h3>
      </div>

      <!-- Two-column grid: left = long paragraph (centered), right = info cards -->
      <div class="IntroBlock__wrap">
        <div class="IntroBlock__left">
          <p class="IntroBlock__lead raleway-reg-p15" v-if="loc.intro_paragraph">
            {{ loc.intro_paragraph }}
          </p>
        </div>

        <div class="IntroBlock__right">
          <div class="InfoCard" v-if="loc.period_text">
            <div class="InfoCard__k raleway-semi-p16">PÉRIODE</div>
            <div class="InfoCard__v raleway-reg-p15">{{ loc.period_text }}</div>
          </div>
          <div class="InfoCard" v-if="loc.duration_text">
            <div class="InfoCard__k raleway-semi-p16">DURÉE</div>
            <div class="InfoCard__v raleway-reg-p15">{{ loc.duration_text }}</div>
          </div>
          <div class="InfoCard" v-if="loc.participants_text">
            <div class="InfoCard__k raleway-semi-p16">NOMBRE DE PARTICIPANTS</div>
            <div class="InfoCard__v raleway-reg-p15">{{ loc.participants_text }}</div>
          </div>
        </div>
      </div>
    </section>
    <!-- <section id="transport"   class="SectionPlaceholder">Transport</section>
    <section id="travailler"  class="SectionPlaceholder">Pour travailler</section>
    <section id="dormir"      class="SectionPlaceholder">Pour dormir</section>
    <section id="detendre"    class="SectionPlaceholder">Pour se détendre</section>
    <section id="depenser"    class="SectionPlaceholder">Pour se dépenser</section>
    <section id="manger"      class="SectionPlaceholder">Pour manger</section>
    <section id="federer"     class="SectionPlaceholder">Pour fédérer</section>
    <section id="programme"   class="SectionPlaceholder">Le programme</section>
    <section id="devis"       class="SectionPlaceholder">Le devis</section>
    <section id="cadeaux"     class="SectionPlaceholder">Nos cadeaux</section> -->

    <!-- <section v-if="hasGallery" id="gallery" class="GalleryGrid">
      <img
        v-for="(src, i) in loc.gallery_photo_urls"
        :key="i"
        :src="src"
        :alt="`${loc.title} – photo ${i+1}`"
        loading="lazy"
      />
    </section> -->
    <EcoCommitmentsSection :items="loc.eco_commitments" />
     <WorkSection
    v-if="(loc.work_gallery_photo_urls || []).length || loc.work_text"
     :text="loc.work_text"
     :images="loc.work_gallery_photo_urls || []"
   />
   <CapacityTableSection v-if="loc && loc.capacity_table" :table="loc.capacity_table" />
   <AdditionalInfosSection :items="loc.services || []" />
   <WorkSpacesSection
  v-if="(loc.work_gallery_photo_urls || []).length || (loc.work_rooms || []).length"
  :images="loc.work_gallery_photo_urls || []"
  :rooms="loc.work_rooms || []"
/>
   <SleepSection
v-if="(loc.sleep_gallery_photo_urls || []).length || loc.sleep_text"
   :text="loc.sleep_text"
   :images="loc.sleep_gallery_photo_urls || []"
 />
 <RoomBadges :badges="loc.room_badges"/>
 <MealPlanGrid v-if="(loc.meal_plan_sections || []).length" :sections="loc.meal_plan_sections || []" />
    <RelaxSection
     v-if="(loc.relax_gallery_photo_urls || []).length || loc.relax_text"
     :text="loc.relax_text"
     :images="loc.relax_gallery_photo_urls || []"
   />
   <InfoValuesBlock
  :info-title="loc.info_title"
  :info-para-1="loc.info_para_1"
  :info-para-2="loc.info_para_2"
  :values-title="loc.values_title"
  :values="loc.values"
/>
   <InfoBanner>
      Certains éléments sont proposés en supplément. Si vous souhaitez inclure une activité dans votre programme,
      nous vous invitons à contacter nos équipes afin d’en connaître les modalités et le tarif.
    </InfoBanner>
   <ExerciseSection
     v-if="(loc.exercise_gallery_photo_urls || []).length || loc.exercise_text"
     :text="loc.exercise_text"
     :images="loc.exercise_gallery_photo_urls || []"
     :captions="[]"
   />
   <InfoBanner>
      Certains éléments sont proposés en supplément. Si vous souhaitez inclure une activité dans votre programme,
      nous vous invitons à contacter nos équipes afin d’en connaître les modalités et le tarif.
    </InfoBanner>
    <QuotePricingTables
     v-if="(parsedBreakdown.sections || []).length"
   :breakdown="parsedBreakdown"
  />
  <TeamBuildingSection
  v-if="(loc.team_building_activities || []).length"
  :items="loc.team_building_activities"
/>

  <ProgramTimeline
      v-if="(loc.program_sections || []).length"
      :sections="loc.program_sections"
    />
       <section id="devis">
      <PublicQuoteActions
        :quote-number="quoteNumber"
        :location-name="loc.title"
        :customer-name="customerName"
        :formspree-approve-url="approveEndpoint"
        :formspree-change-url="changeEndpoint"
      />
    </section>




    <TransportSection
      v-if="(loc.starting_points || []).length"
      :points="loc.starting_points"
      :venue="{ lat: Number(loc.latitude), lng: Number(loc.longitude) }"
    />


    <WhyChooseHortense />

    <GiftsHortense />


    <CgvSection
      v-if="loc.terms_left_text || loc.terms_right_text"
      :left-text="loc.terms_left_text"
      :right-text="loc.terms_right_text"
      section-id="cgv"
    >
    </CgvSection>
  </div>

</template>

<script>
import EcoCommitmentsSection from './EcoCommitmentsSection.vue';
import WorkSection from './WorkSection.vue'
import CapacityTableSection from './CapacityTableSection.vue'
import AdditionalInfosSection from './AdditionalInfosSection.vue'
import SleepSection from './SleepSection.vue';
import RelaxSection from './RelaxSection.vue'
import ExerciseSection from './ExerciseSection.vue'
import PublicQuoteActions from './PublicQuoteActions.vue'
import QuotePricingTables from './QuotePricingTables.vue'
import CgvSection from './CgvSection.vue'
import ProgramTimeline from './ProgramTimeline.vue'
import WhyChooseHortense from './WhyChooseHortense.vue';
import GiftsHortense from './GiftsHortense.vue';
import MealPlanGrid from './MealPlanGrid.vue'
import TransportSection from './TransportSection.vue'
import MapboxModal from './MapboxModal.vue'
import WorkSpacesSection from './WorkSpacesSection.vue'
import TeamBuildingSection from './TeamBuildingSection.vue'
import InfoBanner from './InfoBanner.vue'
import RoomBadges from './RoomBadges.vue';
import InfoValuesBlock from './InfoValuesBlock.vue'

export default {
  name: 'LocationShow',
  components: { EcoCommitmentsSection, WorkSection, CapacityTableSection, AdditionalInfosSection, SleepSection, RelaxSection, ExerciseSection, PublicQuoteActions, QuotePricingTables, CgvSection, ProgramTimeline, WhyChooseHortense, GiftsHortense, MealPlanGrid, TransportSection, MapboxModal, WorkSpacesSection, TeamBuildingSection, InfoBanner, RoomBadges, InfoValuesBlock },
  props: {
    locationId: { type: [String, Number], required: true },
    approveEndpoint: { type: String, required: true },
    changeEndpoint:  { type: String, required: true },
    quoteNumber:     { type: String, default: '' },
    customerName:    { type: String, default: '' },
    quoteBreakdown:  { type: [Object, String], default: () => ({}) }
  },
  data () {
    return {
      showMap: false,
      loading: true,
      mapboxToken: "pk.eyJ1IjoiaG9ydGVuc2VncmVlbiIsImEiOiJja3N1Nm9iNGEwNjUyMm9xY2RlMDlwYWsxIn0.AMGi9L_80RYWk4sB5JYU5w",
      isGalleryOpen: false,
      isPhone: window.innerWidth < 768,
      endpoint: '',
      logoSrc: '/images/Logo hortense.svg',
      loc: {
        title: '', subtitle: '', standing: 'unrated',
        cover_photo_url: null,
        gallery_photo_urls: [],
        address1: '', address2: '', zip: '', city: '', country: '',
        latitude: null, longitude: null,
        highlights: [],
        intro_paragraph: '', period_text: '', duration_text: '', participants_text: ''
      },
      navLinks: [
        { id: 'transport',  label: 'TRANSPORT' },
        { id: 'travailler', label: 'POUR TRAVAILLER' },
        { id: 'dormir',     label: 'POUR DORMIR' },
        { id: 'detendre',   label: 'POUR SE DÉTENDRE' },
        { id: 'depenser',   label: 'POUR SE DÉPENSER' },
        { id: 'manger',     label: 'POUR MANGER' },
        { id: 'federer',    label: 'POUR FÉDÉRER' },
        { id: 'programme',  label: 'LE PROGRAMME' },
        { id: 'devis',      label: 'LE DEVIS' },
        { id: 'cadeaux',    label: 'NOS CADEAUX' }
      ],
      _io: null,
      icons: {
        nature: `
          <svg viewBox="0 0 48 48" width="56" height="56" fill="none" stroke="#2d5f49" stroke-width="2">
            <path d="M24 6c8 8-8 12 0 22M24 6c-8 8 8 12 0 22"/><path d="M24 28v14"/><path d="M15 20c1 6 5 8 9 8s8-2 9-8"/>
          </svg>`,
        plein_air: `
          <svg viewBox="0 0 48 48" width="56" height="56" fill="none" stroke="#2d5f49" stroke-width="2">
            <circle cx="24" cy="24" r="8"/><path d="M24 4v8M24 36v8M4 24h8M36 24h8M9 9l6 6M33 33l6 6M9 39l6-6M33 15l6-6"/>
          </svg>`,
        deconnexion: `
          <svg viewBox="0 0 48 48" width="56" height="56" fill="none" stroke="#2d5f49" stroke-width="2">
            <rect x="10" y="12" width="28" height="24" rx="4"/><path d="M24 18v12"/>
          </svg>`,
        eco_responsabilite: `
          <svg viewBox="0 0 48 48" width="56" height="56" fill="none" stroke="#2d5f49" stroke-width="2">
            <path d="M28 6c6 2 10 6 12 12-6 2-10-2-12-12z"/><path d="M8 30c8 0 14-4 16-10-2 10-8 18-16 18"/><path d="M22 32l8 8h8"/>
          </svg>`,
        default: `
          <svg viewBox="0 0 48 48" width="56" height="56" fill="none" stroke="#2d5f49" stroke-width="2">
            <circle cx="24" cy="24" r="10"/>
          </svg>`
      }
    }
  },
  computed: {

    mapCenter () {
      const { longitude, latitude } = this.loc || {}
      if (typeof longitude === 'number' && typeof latitude === 'number') return [longitude, latitude]
      return [2.3522, 48.8566]
    },
    displayAddress () { return this.fullAddress || (this.loc.latitude && this.loc.longitude) },
    heroStyle () {
      return this.loc.cover_photo_url ? { backgroundImage: `url(${this.loc.cover_photo_url})` } : {};
    },
    hasGallery () {
      return (this.loc.gallery_photo_urls || []).length > 0;
    },
    starsText () {
        const map = { unrated: 0, one_star: 1, two_star: 2, three_star: 3, four_star: 4, five_star: 5 }
        const n = map[this.loc.standing] || 0
        return n ? '☆'.repeat(n) : ''
    },
    fullAddress () {
      const { address1, address2, zip, city, country } = this.loc;
      const zc = [zip, city].filter(Boolean).join(' ');
      return [address1, address2, zc, country].filter(Boolean).join(', ');
    },
    mapUrl () {
      const { latitude, longitude } = this.loc;
      if (latitude && longitude) return `https://www.google.com/maps?q=${latitude},${longitude}`;
      if (this.fullAddress) return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(this.fullAddress)}`;
      return null;
    },
    topHighlights () {
      return (this.loc.highlights || []).slice(0, 4);
    },
     parsedBreakdown () {
     const v = this.quoteBreakdown
     if (!v) return {}
     if (typeof v === 'string') {
       try { return JSON.parse(v) } catch (e) {
         console.warn('[LocationShow] invalid quoteBreakdown JSON', e)
         return {}
       }
     }
     return v
   },
  },
  methods: {
    openMap () {
      this.showMap = true;
    },
    openGallery () {
      this.isGalleryOpen = true;
      document.documentElement.style.overflow = 'hidden'; 
      this.$nextTick(() => this.$refs.galleryModal?.focus());
    },
    closeGallery () {
      this.isGalleryOpen = false;
      document.documentElement.style.overflow = ''; 
    },
    buildEndpoint () {
      const attr = this.$el && this.$el.getAttribute && this.$el.getAttribute('endpoint');
      if (attr) return attr;
      return `/admin/seminars/locations/${this.locationId}.json`;
    },
    async fetchData () {
      try {
        const res = await fetch(this.endpoint, { credentials: 'same-origin' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        this.loc = data || this.loc;
      } catch (e) {
        console.error('LocationShow fetch failed:', e);
      } finally {
        this.loading = false;
        this.observeNav();
      }
    },
    scrollTo (id) {
      const el = document.getElementById(id);
      if (!el) return;
      const offset = 70;
      const y = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    },
    observeNav () {
      const nav = this.$refs.nav;
      if (!nav || this._io) return;
      this._io = new IntersectionObserver(entries => {
        entries.forEach(e => nav.classList.toggle('is-floating', e.intersectionRatio < 1));
      }, { threshold: [1] });
      this._io.observe(nav);
    },
    highlightLabel (kind) {
      const map = {
        nature: 'NATURE',
        plein_air: 'PLEIN AIR',
        deconnexion: 'DÉCONNEXION',
        eco_responsabilite: 'ÉCO-RESPONSABILITÉ'
      };
      return map[kind] || (kind || '').toUpperCase();
    }
  },
  mounted () {
    this.endpoint = this.buildEndpoint();
    this.fetchData();
  },
  beforeDestroy () { if (this._io) this._io.disconnect(); }
}
</script>

<style>
.LocationShow.p * {
  font-family: 'Raleway',;
}
.LocationShow.loading { opacity: .92; }
.Hero { position: relative; min-height: clamp(300px, 31vw, 680px); background: #0b0b0b center/cover no-repeat; color:#fff; }
.Hero__overlay { position:absolute; inset:0; background:linear-gradient(180deg, rgba(0,0,0,.30), rgba(0,0,0,.55)); }
.Hero__inner { position:relative; z-index:1; max-width:1200px; margin:0 auto; padding:clamp(16px,3vw,32px); display:grid; gap:clamp(8px,1.2vw,16px); align-content:center; min-height:inherit; }
.Hero__logo { width:clamp(120px,18vw,220px); filter:drop-shadow(0 1px 1px rgba(0,0,0,.5)); }
.Hero__stars { letter-spacing:.2rem; font-size:clamp(16px,2.2vw,24px); opacity:.95; }
.Hero__subtitle { font-family: 'Raleway', sans-serif; font-size:clamp(16px,2.4vw,28px); font-style:italic; margin:0; text-shadow:0 2px 6px rgba(0,0,0,.35); }
.Hero__galleryBtn{
  position: absolute;
  right: clamp(12px, 2vw, 22px);
  bottom: clamp(12px, 2vw, 22px);
  padding: 10px 14px;
  border-radius: 10px;
  background: rgba(0,0,0,.55);
  color: #fff;
  text-decoration: none;
  backdrop-filter: blur(2px);
  border: 1px solid rgba(255,255,255,.25);
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  z-index: 2;
}
.Hero__galleryBtn:hover{ background: rgba(0,0,0,.65); }
.Hero__galleryIcon{ font-size: 18px; transform: translateY(-1px); }
.GalleryModal{
  position: fixed;
  inset: 0;
  background: rgba(245,246,248,.97); 
  z-index: 1000;
  display: grid;
  grid-template-rows: auto 1fr;
}

.GalleryModal__close{
  position: fixed;
  top: 14px;
  right: 14px;
  width: 42px; height: 42px;
  border-radius: 999px;
  border: 1px solid rgba(0,0,0,.15);
  background: #fff;
  color: #111;
  font-size: 28px;
  line-height: 38px;
  cursor: pointer;
  box-shadow: 0 6px 20px rgba(0,0,0,.12);
  z-index: 1001;
}
.GalleryModal__close:hover{ background:#f7f7f7; }

.GalleryModal__content{
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  padding: clamp(16px, 3vw, 28px);
  overflow: auto;
  display: grid;
  gap: clamp(10px, 1.6vw, 16px);
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  align-content: start;
}

.GalleryModal__content img{
  width: 100%;
  height: clamp(200px, 24vw, 340px);
  object-fit: cover;
  border-radius: 12px;
  background: #eaecee;
}

@media (max-width: 640px){
  .GalleryModal__close{ top: 10px; right: 10px; width: 38px; height: 38px; font-size: 24px; }
  .GalleryModal__content{ grid-template-columns: 1fr 1fr; }
}
.AnchorNav{
  position: sticky;
  top: 0;
  z-index: 30;
  background: #0b0b0b;
  color: #fff;
  border-top: 1px solid rgba(255,255,255,.08);
  border-bottom: 1px solid rgba(255,255,255,.08);
  width: 100%;
}

.AnchorNav__inner{
  /* max-width: 1200px;      */
  margin-inline: auto;           
  padding-inline: 12px;           
}

.AnchorNav__scroller{
  --pad: clamp(12px, 3vw, 28px);
  display: flex;
  gap: 24px;
  justify-content: center;       
  overflow-x: auto;              
  scrollbar-width: thin;
  padding: 12px var(--pad);

  -webkit-mask-image: linear-gradient(to right, transparent, #000 20px, #000 calc(100% - 20px), transparent);
          mask-image: linear-gradient(to right, transparent, #000 20px, #000 calc(100% - 20px), transparent);
}

.AnchorNav__link{
  font-family: 'Raleway', sans-serif;
  color: #fff;
  text-decoration: none;
  font-weight: 700;
  white-space: nowrap;
  opacity: .95;
}
.AnchorNav__link:hover{  color: #fff; }

.AnchorNav.is-floating{ box-shadow: 0 2px 12px rgba(0,0,0,.18); }

.AddressHighlight { padding: 18px 16px 8px; }
.AddressHighlight__container { max-width: 1200px; margin: 0 auto; text-align: center; }
.AddressHighlight__address { font-family: 'Raleway'; font-size: clamp(18px, 3vw, 22px); margin: 6px 0 4px; }
.AddressHighlight__map { margin: 2px 0 20px; color:#2d5f49; font-weight:700; }
.AddressHighlight__map a { color:#2d5f49; text-decoration: underline; }
.AddressHighlight .pin { margin-right: 6px; }

.AddressHighlight__grid {
  display:grid; gap: 18px; padding-top: 18px; border-top: 1px solid #eee;
  grid-template-columns: repeat(4, 1fr);
}
.AHCard { display:grid; justify-items:center; gap:8px; }
.AHCard__icon { width:56px; height:56px; }
.AHCard__label { color:#2d5f49;}

@media (max-width: 860px){
  .AddressHighlight__grid { grid-template-columns: repeat(2, 1fr); row-gap: 24px; }
}

.IntroBlock{
  padding: clamp(28px, 6vw, 80px) 16px 8px;
}

.IntroBlock__head{
  max-width: 1200px;
  margin: 0 auto clamp(18px, 4vw, 36px);
  text-align: center;
}
.IntroBlock__kick{
  color: #0e0e0e;
  line-height: 1.1;
  margin: 0 0 4px;
}
.IntroBlock__big{
  color: #0d0d0d;
  line-height: 1.05;
  margin: 0;
}

.IntroBlock__wrap{
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  gap: clamp(18px, 3vw, 28px);
  grid-template-columns: minmax(0, 1.1fr) minmax(280px, .9fr);
  align-items: start;
}

.IntroBlock__left{
  display: flex;
  justify-content: center;
}
.IntroBlock__lead{
  max-width: 820px;
  margin: 0 auto;
  text-align: center;
  color: #1a1a1a;
  line-height: 1.9;
}

.IntroBlock__right{
  display: grid;
  gap: clamp(12px, 2vw, 16px);
  align-content: start;
}

.InfoCard{
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 14px;
  align-items: center;
  padding: clamp(18px, 2.2vw, 26px) clamp(18px, 2.4vw, 28px);
  background: #f4f6f5;
  border-radius: 16px;
}
.InfoCard__k{
  letter-spacing: .3px;
  color: #2d5f49;
  white-space: pre-wrap;
}
.InfoCard__v{
  color: #0f0f0f;
  text-align: right;

}

@media (max-width: 1024px){
  .IntroBlock__wrap{ grid-template-columns: 1fr; }
  .IntroBlock__right{ gap: 14px; }
  .InfoCard{ grid-template-columns: 1fr; }
  .InfoCard__v{ text-align: left; }
}


.SectionPlaceholder { min-height:55vh; padding:48px 20px; max-width:1100px; margin:0 auto; }
.GalleryGrid { display:grid; gap:10px; padding:24px 20px; grid-template-columns:repeat(auto-fill, minmax(220px, 1fr)); }
.GalleryGrid img { width:100%; height:220px; object-fit:cover; border-radius:10px; }

@media (min-width:960px){
  .Hero__inner{ padding:48px }
  .SectionPlaceholder{ padding:72px 24px }
}
.MapOpenBtn {
  background: none; border: none; padding: 0;
  color: #2d5f49; font-weight: 700; cursor: pointer;
  text-decoration: underline;
}
.MapOpenBtn:hover { opacity: .9; }
.btn-galerie-seminar {
      position: absolute;
      bottom: 17%;
      right: 8px;
      cursor: pointer;
      .galerie-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #000000 0% 0% no-repeat padding-box;
        background-color: rgba(0, 0, 0, 0.6);
        border-radius: 60px;
        padding: 1rem 2rem;
        color: white;
        width: 120px;
        height: 34px;
        margin-left: auto;
      }
    }
    .btn-galerie-seminar-phone {
      display: none;
    }
    @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
      .btn-galerie-seminar {
        bottom: 25%;
        left: 35%;

        .galerie-icon {
          margin-left: unset;
        }
      }

    }
</style>